import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';
import { HONAPOK, JELLEG_NEV, fmt, fmtMax, gjLapNyomtat, hibaSzoveg, huDatum } from './gj-nyomtatas';

/*  GÉPJÁRMŰ – ÚTNYILVÁNTARTÁS (Kulcs-Autó mintájára). Járművenként és hónaponként a napi utak: dátum, sofőr,
 *  honnan → hová (a címtárból vagy szabad szöveggel), az út célja, km, jelleg (üzleti / magán / munkába járás),
 *  norma-korrekciók és km-óra. A NAV szerinti kötelező tartalmat a nyomtatott lap és az Excel is hordozza.
 *   – Gyors felvétel a rács tetején: a két cím ismert távolságából a km magától kitöltődik, a visszaút egy
 *     jelöléssel kész, a mentett körútból (telephely → partner → telephely) egy kattintással.
 *   – Óraállás-ellenőrzés: a km-óra nyitó/záró állása és a rögzített utak km-e közti eltérés, a hézagok.
 *   – Tervező: a hónap üzleti útjainak terve a cél-km-re (vagy az óraállásra), munkanapokra, előnézettel.
 *   – Szerkesztés zárral (gepjarmu_ut); a kinyomtatott kiküldetési rendelvény útja csak olvasható.
 *  Backend: backend/gepjarmu-ut.js. */
@Component({
  selector: 'app-gj-utnyilvantartas',
  templateUrl: './utnyilvantartas.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjUtnyilvantartasComponent implements OnInit, OnDestroy {
  readonly honapok = HONAPOK;
  readonly jellegNev = JELLEG_NEV;
  readonly jellegek = ['uzleti', 'magan', 'munkaba'];
  torzs: any = { jarmuvek: [], soforok: [], cimek: [], korrekciok: [] };
  jarmuId = '';
  ho = new Date().getMonth() + 1;
  adat: any = null;
  korutak: any[] = [];
  telephely: any = null;
  uj: any = null;
  szerk: any = null;
  terv: any = null;
  tervEredmeny: any = null;
  dolgozik = false;
  zar: SzerkZar | null = null;
  private zarKor = 0;
  private sub?: Subscription;
  private elozoKulcs = '';
  fmt = fmt; fmtMax = fmtMax; huDatum = huDatum;

  constructor(public gj: GepjarmuService, private http: HttpClient, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ev() { return this.gj.aktiv.ev; }
  get ir() { return this.gj.ir; }
  get jarmu(): any { return this.torzs.jarmuvek.find((j: any) => j.id === this.jarmuId); }
  get kezdoNap(): string { return `${this.ev}-${String(this.ho).padStart(2, '0')}-01`; }
  get vegNap(): string { return `${this.ev}-${String(this.ho).padStart(2, '0')}-${String(new Date(this.ev, this.ho, 0).getDate()).padStart(2, '0')}`; }
  get partnerCimek(): any[] { return this.torzs.cimek.filter((c: any) => +c.aktiv && c.id !== this.telephely?.id); }
  get aktivCimek(): any[] { return this.torzs.cimek.filter((c: any) => +c.aktiv); }
  get aktivSoforok(): any[] { return this.torzs.soforok.filter((s: any) => +s.aktiv); }

  async ngOnInit() {
    await this.gj.init();
    this.sub = this.gj.aktiv$.subscribe((a) => {
      const k = `${a.ugyfelId}|${a.ev}`;
      if (k === this.elozoKulcs) return;
      //  Cégváltáskor a törzsek is újratöltődnek; évváltáskor (fejléc vagy a hónapléptető) csak az utak.
      const cegValt = !this.elozoKulcs.startsWith(`${a.ugyfelId}|`);
      this.elozoKulcs = k;
      this.betolt(cegValt);
    });
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.zarElenged(); }

  async betolt(torzsIs = true) {
    if (!this.u) { this.adat = null; this.torzs = { jarmuvek: [], soforok: [], cimek: [], korrekciok: [] }; return; }
    try {
      if (torzsIs || !this.torzs.jarmuvek.length) {
        this.torzs = await this.gj.get(`ut:/torzs/${this.u}`);
        if (!this.torzs.jarmuvek.some((j: any) => j.id === this.jarmuId)) this.jarmuId = (this.torzs.jarmuvek.find((j: any) => +j.aktiv) || this.torzs.jarmuvek[0])?.id || '';
      }
      await this.frissit();
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült betölteni.')); }
  }
  async frissit() {
    if (!this.u || !this.jarmuId) { this.adat = null; return; }
    try {
      const [adat, k] = await Promise.all([
        this.gj.get(`ut:/utak/${this.u}?jarmu_id=${this.jarmuId}&ev=${this.ev}&ho=${this.ho}`),
        this.gj.get(`ut:/korutak/${this.u}?jarmu_id=${this.jarmuId}`),
      ]);
      this.adat = adat; this.korutak = k.korutak || []; this.telephely = k.telephely;
      if (this.ir) this.ujSor();
    } catch (e: any) { this.adat = null; this.hiba(hibaSzoveg(e, 'Nem sikerült betölteni az utakat.')); }
  }
  hoLep(d: number) {
    let ho = this.ho + d, ev = this.ev;
    if (ho < 1) { ho = 12; ev--; } else if (ho > 12) { ho = 1; ev++; }
    this.ho = ho;
    if (ev !== this.ev) { this.gj.setAktiv({ ev }); return; }   // az év a fejlécé – a feliratkozás tölt újra
    this.frissit();
  }
  /*  60/1992. Korm. r. 2. melléklet: egy útszakaszra csak EGY körülmény-szorzó; a téli és a klíma pótlék a
   *  naptári időszakra magától jár (a kiszolgáló számolja), ezért itt nem választható. */
  private static readonly IDOSZAKOS = new Set(['teli', 'klima']);
  get korrSzorzok(): any[] { return (this.torzs.korrekciok || []).filter((k: any) => !k.idoszak && !GjUtnyilvantartasComponent.IDOSZAKOS.has(k.kod)); }
  szorzoja(ut: any): string { return (ut?.korrekcio || []).find((k: string) => !GjUtnyilvantartasComponent.IDOSZAKOS.has(k)) || ''; }
  korrNev(kod: string): string { return this.torzs.korrekciok.find((k: any) => k.kod === kod)?.nev || kod; }
  cimNev(id: string): string { return this.torzs.cimek.find((c: any) => c.id === id)?.nev || ''; }

  /* ── gyors felvétel ── */
  ujSor(elozo?: any) {
    const utolso = this.adat?.utak?.[this.adat.utak.length - 1];
    const ma = new Date().toISOString().slice(0, 10);
    const alapDatum = ma >= this.kezdoNap && ma <= this.vegNap ? ma : (utolso?.datum || this.kezdoNap);
    this.uj = { datum: elozo?.datum || alapDatum, sofor_id: elozo?.sofor_id || this.jarmu?.alap_sofor_id || '', honnan_cim_id: this.telephely?.id || '', hova_cim_id: '', honnan: '', hova: '',
      cel: '', km: null, jelleg: 'uzleti', km_tol: utolso?.km_ig ?? null, visszaut: false, korut: '' };
  }
  async kmJavasol(s: any) {
    if (!s?.honnan_cim_id || !s?.hova_cim_id) return;
    try {
      const r: any = await this.gj.get(`ut:/tavolsag/${this.u}?a=${s.honnan_cim_id}&b=${s.hova_cim_id}`);
      if (r?.km != null) s.km = r.km;
    } catch { /* nincs javaslat */ }
  }
  korutValaszt(cimId: string) {
    const k = this.korutak.find((x) => x.cim_id === cimId);
    if (!k || !this.telephely) return;
    Object.assign(this.uj, { honnan_cim_id: this.telephely.id, hova_cim_id: k.cim_id, honnan: '', hova: '', km: k.km, visszaut: true, jelleg: 'uzleti', cel: this.uj.cel || 'Üzleti megbeszélés' });
    this.uj.korut = '';
  }
  async ujMent() {
    const s = this.uj;
    try {
      await this.gj.post(`ut:/ut/${this.u}`, { ...s, jarmu_id: this.jarmuId, km_ig: s.km_tol != null && s.km != null ? Math.round(Number(s.km_tol) + Number(s.km)) : null });
      this.ok(s.visszaut ? 'Az út és a visszaút rögzítve.' : 'Út rögzítve.');
      const elozo = { datum: s.datum, sofor_id: s.sofor_id };
      await this.frissit(); this.ujSor(elozo);
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült menteni.')); }
  }

  /* ── szerkesztő (zárral) ── */
  zarolt(ut: any): string | null {
    if (ut?.rendelveny_nyomtatva) return `A(z) ${ut.rendelveny_sorszam} kiküldetési rendelvény ki van nyomtatva – az út nem módosítható.`;
    if (ut?.rendelveny_ber_atadva) return `A(z) ${ut.rendelveny_sorszam} rendelvény át van adva a Bérbe – előbb vond vissza az átadást.`;
    return null;
  }
  nyit(ut: any) {
    this.szerk = { ...ut, korrSzorzo: this.szorzoja(ut), sofor_id: ut.sofor_id || '',
      honnan_cim_id: ut.honnan_cim_id || '', hova_cim_id: ut.hova_cim_id || '' };
    if (this.ir && !this.zarolt(ut)) this.zarFoglal(ut.id);
  }
  get szerkIrhato(): boolean { return this.ir && !this.zarolt(this.szerk) && !(this.zar && !this.zar.irhato); }
  private async zarFoglal(id: string) {
    this.zarElenged();
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('gepjarmu', 'gepjarmu_ut', id, { ujratolt: () => this.ujratolt(id) });
    if (kor !== this.zarKor || this.szerk?.id !== id) { z?.felenged(); return; }
    this.zar = z;
  }
  private zarElenged() { this.zarKor++; this.zar?.felenged(); this.zar = null; }
  private async ujratolt(id: string) {
    await this.frissit();
    const ut = this.adat?.utak?.find((x: any) => x.id === id);
    if (ut && this.szerk?.id === id) this.szerk = { ...ut, korrSzorzo: this.szorzoja(ut) };
  }
  bezar() { this.szerk = null; this.zarElenged(); }
  cimValt(s: any, mezo: 'honnan' | 'hova') { if (s[`${mezo}_cim_id`]) s[mezo] = ''; this.kmJavasol(s); }
  async szerkMent() {
    if (!this.szerkIrhato) return;
    const s = this.szerk;
    const korrekcio = s.korrSzorzo ? [s.korrSzorzo] : [];
    try {
      await this.gj.put(`ut:/ut/${s.id}`, { jarmu_id: s.jarmu_id, datum: s.datum, sofor_id: s.sofor_id || null, honnan_cim_id: s.honnan_cim_id || null, hova_cim_id: s.hova_cim_id || null,
        honnan: s.honnan_cim_id ? '' : s.honnan, hova: s.hova_cim_id ? '' : s.hova, cel: s.cel, km: s.km, jelleg: s.jelleg, korrekcio, km_tol: s.km_tol, km_ig: s.km_ig, megjegyzes: s.megjegyzes });
      this.bezar(); this.ok('Út mentve.'); await this.frissit();
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült menteni.')); }
  }
  async torol() {
    if (!this.szerkIrhato) return;
    const a = await this.alert.create({ header: 'Út törlése', message: `${huDatum(this.szerk.datum)} · ${this.szerk.honnan} → ${this.szerk.hova} (${fmtMax(this.szerk.km, 1)} km)`,
      buttons: [{ text: 'Mégsem', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: () => this.torolVeg() }] });
    await a.present();
  }
  private async torolVeg() {
    try { await this.gj.del(`ut:/ut/${this.szerk.id}`); this.bezar(); this.ok('Út törölve.'); await this.frissit(); }
    catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült törölni.')); }
  }

  /* ── tervező ── */
  tervNyit() {
    this.tervEredmeny = null;
    this.terv = { km_osszes: null, uzleti_szazalek: this.jarmu?.magan ? 100 : 90, korut: true, munkaba: false, csak_munkanap: true, felulir: false,
      sofor_id: this.jarmu?.alap_sofor_id || '', partnerek: Object.fromEntries(this.korutak.map((k) => [k.cim_id, k.fajta !== 'magan'])), cel: '' };
  }
  get tervPartnerek(): any[] { return this.korutak.filter((k) => k.fajta !== 'magan'); }
  private tervTorzs(elonezet: boolean) {
    const t = this.terv;
    return { jarmu_id: this.jarmuId, ev: this.ev, ho: this.ho, km_osszes: t.km_osszes === '' ? null : t.km_osszes, uzleti_szazalek: t.uzleti_szazalek, korut: t.korut,
      munkaba: t.munkaba, csak_munkanap: t.csak_munkanap, felulir: t.felulir, sofor_id: t.sofor_id || null, cel: t.cel || null, elonezet,
      partner_cim_idk: Object.keys(t.partnerek).filter((k) => t.partnerek[k]) };
  }
  async tervElonezet() {
    this.dolgozik = true;
    try { this.tervEredmeny = await this.gj.post(`ut:/tervez/${this.u}`, this.tervTorzs(true)); }
    catch (e: any) { this.tervEredmeny = null; this.hiba(hibaSzoveg(e, 'Nem sikerült a tervezés.')); }
    finally { this.dolgozik = false; }
  }
  async tervAlkalmaz() {
    this.dolgozik = true;
    try {
      const r: any = await this.gj.post(`ut:/tervez/${this.u}`, this.tervTorzs(false));
      this.terv = null; this.tervEredmeny = null; this.ok(`${r.letrehozva} tervezett út rögzítve.`); await this.frissit();
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült a tervezés.')); }
    finally { this.dolgozik = false; }
  }

  /* ── nyomtatás, export ── */
  async nyomtat() {
    try { await gjLapNyomtat(this.http, `/utnyilvantartas/${this.u}/nyomtat?jarmu_id=${this.jarmuId}&ev=${this.ev}&ho=${this.ho}`, true); }
    catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült a nyomtatás.')); }
  }
  async excel() {
    try { await this.gj.getFajl(`ut:/utnyilvantartas/${this.u}/xlsx?jarmu_id=${this.jarmuId}&ev=${this.ev}`, `utnyilvantartas-${this.jarmu?.rendszam || ''}-${this.ev}.xlsx`); }
    catch { this.hiba('Nem sikerült az Excel-export.'); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4800, color: 'danger' })).present(); }
}
